import { ColumnDetails, ColumnType } from '../../../../../../../../grid/types/common';
import { translateFn } from '../../../../../../../../utils/translator.helper';
import { getWebAccessPermissionFormOptions } from '../../../../../utils/uiSettings/contentControl/content-control.values';

export enum Column {
  WEB_ADDRESS = 1,
  PERMISSION,
}

export enum ColumnKeys {
  WEB_ADDRESS = 'webAddress',
  PERMISSION = 'permission',
}

export const GRID_COLUMNS = [Column.WEB_ADDRESS, Column.PERMISSION];

export const FILTERS = [{ [ColumnKeys.WEB_ADDRESS]: { contains: '' } }, { [ColumnKeys.PERMISSION]: { in: [] } }];
export const PREDEFINED_FILTERS_KEYS = [ColumnKeys.WEB_ADDRESS, ColumnKeys.PERMISSION];

export function getGridColumnDetails(): Array<ColumnDetails<Column, ColumnKeys>> {
  return [
    {
      column: Column.WEB_ADDRESS,
      key: ColumnKeys.WEB_ADDRESS,
      columnName: translateFn('Web address'),
      type: ColumnType.STRING,
      removable: false,
      filteringDisabled: true,
      sortable: true,
    },
    {
      column: Column.PERMISSION,
      key: ColumnKeys.PERMISSION,
      columnName: translateFn('Permission'),
      type: ColumnType.EDITABLE_SELECT,
      values: getWebAccessPermissionFormOptions(),
      removable: false,
      filteringDisabled: false,
      sortable: true,
    },
  ];
}
